import * as ActionType from '../../constants/actionType';

export const resetProtocolState = () => ({type: ActionType.RESET_PROTOCOL_STATE});

export const restoreProtocolState = (state) => ({type: ActionType.RESTORE_PROTOCOL_STATE, data: state});

export const setAvailableProtocols = (protocols) => ({type: ActionType.SET_AVAILABLE_PROTOCOLS, data: protocols});

export const setLastOpenedProtocol = (protocol) => ({type: ActionType.SET_LAST_OPENED_PROTOCOL, data: protocol});

export const setOpenedProtocolCheckpoint = (protocol) => ({
  type: ActionType.SET_LAST_SAVED_PROTOCOL_STATE,
  data: {...protocol},
});

export const setTemporaryUnsavedProtocolData = (protocol) => ({
  type: ActionType.SET_TEMPORARY_UNSAVED_PROTOCOL_DATA,
  data: protocol,
});

export const clearTemporaryUnsavedProtocolData = () => ({
  type: ActionType.SET_TEMPORARY_UNSAVED_PROTOCOL_DATA,
  data: null,
});

export const setFavoriteProtocols = (data) => ({
  type: ActionType.ProtocolStateActionTypes.SET_FAVORITE_PROTOCOLS,
  data,
});

export const setOpenedProtocolEjectToCaddy = (isEjectToCaddy) => ({
  type: ActionType.SET_OPENED_PROTOCOL_EJECT_TO_CADDY,
  isEjectToCaddy,
});
